import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ServicioService, UsuariosService, StorageService } from '../../servicios/index.service';
import { FormGroup, FormControl,Validators } from '@angular/forms';
declare var $;

@Component({
  selector: 'app-usuario',
  templateUrl: './usuario.component.html',
  styles: []
})
export class UsuarioComponent implements OnInit {

  id:any;
  datosUsers:any;
  datosUnidad:any = {};
  c_carga:any;
  matricula:any;
  nom_unidad:any;
  t_unidad:any;
  formAsignacion:FormGroup;
  formUnidad:FormGroup;
  verpw:boolean = false;
  btn_ocultar:boolean = false;
  txt_pw:boolean = false;
  edit_pw:boolean = false;
  btnCancelaEdit:boolean = false;
  btnEditar:boolean = false;
  valueInput:any ="";
  datosUpdate:any;
  formUser:any;
  msjUser:boolean;
  select_t_unidad:any;
  select_t_carga:any;
  err_msj_t_unidad:boolean = false;
  tipo_unidad:any;
  vehiculo_esp:any;
  remolque_t_cc_form:any;
  remolque_t_cr_form:any;
  accesorios_form:any;
  tipo_lic:any;
  check_perm_fed:boolean = true;
  check_perm_fed_false:boolean = false;
  check_remolque:boolean =  true;
  check_remolque_false:boolean = false;
  permiso_fed_DB:any;
  remolque_DB:any;
  remolque_t_ciculacion:any;
  remolque_placas:any;

  constructor( private route: ActivatedRoute, private _servicio:ServicioService,
                private _usuarios:UsuariosService, private router:Router, private _storage:StorageService ) {
    this.acceso();
    document.getElementById('body').className = 'hold-transition skin-blue sidebar-mini sidebar-collapse';
    this.route.params.subscribe( params=>{
          this.id = params['id'];
          if( this.id == undefined ){
            this.router.navigate(['/usuarios']);
          }
        } );
    this.form_asignacion();
    this.dataUsuario();
  }

  ngOnInit() {
    this.form_user();
    this.form_unidad();
  }

  acceso(){
    let rol:any = this._storage.consult_storage('rol');

    if( rol == "account-espe" || rol == "2" ){

    }else{
      this.router.navigate(["/home"]);
    }
  }

  dataUsuario(){

    this._servicio.getUsers( this.id ).subscribe(usuario=>{
      this.datosUsers = usuario;
    });

    this._servicio.getUsersUnidad( this.id ).subscribe(unidad=>{
      this.datosUnidad = unidad;
    });

  }

  form_asignacion(){
      let emailFormat = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      this.formAsignacion = new FormGroup({
        'nombre' : new FormControl('', [ Validators.required, Validators.minLength(4)]),
        'apellidos' : new FormControl('', [ Validators.required, Validators.minLength(4)]),
        'email' : new FormControl('', [ Validators.required, Validators.pattern(emailFormat)]),
        'f_naci' : new FormControl('', [Validators.pattern("(0[1-9]|1[0-9]|2[0-9]|3[01]).(0[1-9]|1[012]).[0-9]{4}"),
                                        Validators.required]),
        'tel': new FormControl('',[Validators.required, Validators.minLength(10),
                                   Validators.pattern("[0-9]*")]),
        'newpw': new FormControl('', [Validators.minLength(6)]),
        'rol': new FormControl('', [Validators.required]),
        'licencia': new FormControl(''),
        't_licencia': new FormControl('')

      });

  }

  form_user(){
    let userFormat = /[^a-z0-9\_]/;
    this.formUser = new FormGroup({
      'usuario': new FormControl('', [ Validators.required, Validators.minLength(4),
                                       Validators.maxLength(20),Validators.pattern("[a-z]+[0-9]+")])
    });
  }

  guarda_user(){
    let form = this.formUser.value;
    this._usuarios.valida_datos_list(form.usuario).subscribe(data=>{

        if(data.length == 0){
          this._usuarios.valida_datos(this.id).subscribe(data=>{
            console.log(data);
          });

        }else{
          this.msjUser = true;
        }
    });
  }

  guarda_form_asig(){

    let form = this.formAsignacion.value;

      if( form.t_licencia == "" && this.datosUsers.t_licencia !== "" ){
        this.tipo_lic = this.datosUsers.t_licencia;
      }else if(form.t_licencia !== "" && this.datosUsers.t_licencia !== ""){
        this.tipo_lic = form.t_licencia;
      }

      if( form.newpw == "" ){
        this.datosUpdate = { 'nombre':form.nombre, 'apellidos':form.apellidos, 'email': form.email,
        'f_naci':form.f_naci, 'tel':form.tel, 'rol':form.rol, 'licencia':form.licencia, 't_licencia':this.tipo_lic };
      }else{
        this.datosUpdate = { 'nombre':form.nombre, 'apellidos':form.apellidos, 'email': form.email,
        'f_naci':form.f_naci, 'tel':form.tel, 'rol':form.rol, 'pass':form.newpw, 'licencia':form.licencia,
        't_licencia':this.tipo_lic};
      }

      this._servicio.act_datos_user(this.datosUpdate, this.id).subscribe(data=>{
        if(data){
          $("#asignacion").modal('toggle');
          $.notify({
            icon: 'fa fa-user',
            title:"<b>Se editó usuario</b><br>",
            message:"El usuario <b>" + this.id + "</b> se editó correctamente"
          });
          this.dataUsuario();        }
      });



  }
  ver_password(){
    this.verpw = true;
    this.btn_ocultar = true;
    this.txt_pw = true;
  }
  ocultar_password(){
    this.btn_ocultar = false;
    this.verpw = false;
    this.txt_pw = false;
  }

  editar_pw(){
    this.edit_pw = true;
    this.btnEditar = true;
    this.btnCancelaEdit = true;
  }
  cancela_edit(){
    this.btnCancelaEdit = false;
    this.btnEditar = false;
    this.edit_pw = false;
    this.valueInput = "";
  }

  form_unidad(){
    this.formUnidad = new FormGroup({
      "capacidad": new FormControl('',[Validators.required]),
      "placa": new FormControl('',[Validators.required]),
      "unidad_nom": new FormControl('', Validators.required),
      "tipo_uni": new FormControl(''),
      't_unidad_selec':new FormControl(''),
      'v_especializado':new FormControl(''),
      'remolque': new FormControl(''),
      'remolque_ref': new FormControl(''),
      'accesorios': new FormControl(''),
      't_carga': new FormControl(''),
      't_carga_inp': new FormControl(''),
      'color': new FormControl(''),
      'marca': new FormControl(''),
      'modelo': new FormControl(''),
      'permiso_fed_text': new FormControl(''),
      'permiso_fed_si': new FormControl(''),
      'check_perm_fed_false': new FormControl(''),
      'remolque_check': new FormControl(''),
      't_circ_remolque': new FormControl(''),
      'placas_remolque': new FormControl('')

    });
  }

  guarda_form_unidad(){

    let form = this.formUnidad.value;

    if( form.t_unidad_selec == "" && form.tipo_uni == "" ){
      this.tipo_unidad = this.datosUnidad.t_unidad;
      console.log(this.tipo_unidad);
    }else if( form.tipo_uni == "" && form.t_unidad_selec !== "" ){
      this.tipo_unidad = form.t_unidad_selec;
      console.log(this.tipo_unidad);
    }else if(form.tipo_uni !== "" && form.t_unidad_selec == "1"){
      this.tipo_unidad = form.tipo_uni;
      console.log(this.tipo_unidad);
    }else if( form.tipo_uni !== "" && form.t_unidad_selec !== "" ){
      this.tipo_unidad = form.t_unidad_selec;
      console.log(this.tipo_unidad);
    }

    if( form.v_especializado == "vacio" ){
      this.vehiculo_esp = null;
    }else if( form.v_especializado == "" && this.vehiculo_esp == "" || this.vehiculo_esp == undefined){
      if( this.datosUnidad.v_especializado !== "" ){
        this.vehiculo_esp = this.datosUnidad.v_especializado;
      }else{
        this.vehiculo_esp = null;
      }
      console.log(this.vehiculo_esp);
    }else if( form.v_especializado == "" && this.vehiculo_esp !== ""){
      this.vehiculo_esp = this.vehiculo_esp;
      console.log(this.vehiculo_esp);
    }else if( form.v_especializado !== "" && this.vehiculo_esp !== "" ){
      this.vehiculo_esp = form.v_especializado;
      console.log(this.vehiculo_esp);
    }

    if( form.remolque == "vacio" ){
      this.remolque_t_cc_form = null;
    }else if( form.remolque == "" && this.remolque_t_cc_form == "" || this.remolque_t_cc_form == undefined){
      if( this.datosUnidad.remolque !== "" || this.datosUnidad.remolque !== undefined){
        this.remolque_t_cc_form = this.datosUnidad.remolque;
      }else{
        this.remolque_t_cc_form = null;
      }
      console.log(this.remolque_t_cc_form, "Remolque",this.datosUnidad.remolque);
    }else if( form.remolque == "" && this.remolque_t_cc_form !== ""){
      this.remolque_t_cc_form = this.remolque_t_cc_form;
      console.log(this.remolque_t_cc_form);
    }else if( form.remolque !== "" && this.remolque_t_cc_form !== "" ){
      this.remolque_t_cc_form = form.remolque;
      console.log(this.remolque_t_cc_form);
    }

    if( form.remolque_ref == "vacio" ){
      this.remolque_t_cr_form = null;
    }else if( form.remolque_ref == "" && this.remolque_t_cr_form == "" || this.remolque_t_cr_form == undefined){
      if( this.datosUnidad.remolque_ref !== "" ){
        this.remolque_t_cr_form = this.datosUnidad.remolque_ref;
      }else{
        this.remolque_t_cr_form = null;
      }
      console.log(this.remolque_t_cr_form);
    }else if( form.remolque_ref == "" && this.remolque_t_cr_form !== ""){
      this.remolque_t_cr_form = this.remolque_t_cr_form;
      console.log(this.remolque_t_cr_form);
    }else if( form.remolque_ref !== "" && this.remolque_t_cr_form !== "" ){
      this.remolque_t_cr_form = form.remolque_ref;
      console.log(this.remolque_t_cr_form);
    }

    if( form.accesorios == "vacio" ){
      this.accesorios_form = null;
    }else if( form.accesorios == "" && this.accesorios_form == "" || this.accesorios_form == undefined){
      if( this.datosUnidad.accesorios !== "" ){
        this.accesorios_form = this.datosUnidad.accesorios;
      }else{
        this.accesorios_form = null;
      }
      console.log(this.accesorios_form);
    }else if( form.accesorios == "" && this.accesorios_form !== ""){
      this.accesorios_form = this.accesorios_form;
      console.log(this.accesorios_form);
    }else if( form.accesorios !== "" && this.accesorios_form !== "" ){
      this.accesorios_form = form.accesorios;
      console.log(this.accesorios_form);
    }
    if( form.t_carga == "" && this.select_t_carga == "" || this.select_t_carga == undefined ){
      this.select_t_carga = this.datosUnidad.t_carga;
      console.log("1",this.select_t_carga);
    }else if( form.t_carga !== "" && this.select_t_carga == "" || this.select_t_carga == undefined ){
      this.select_t_carga = this.select_t_carga;
      console.log("2",this.select_t_carga);
    }else if(form.t_carga !== "" && form.t_carga == "1"){
      this.select_t_carga = form.t_carga_inp;
      console.log("3",this.select_t_carga);
    }

    console.log("select_t_carga",this.select_t_carga);
    /*
    else if( form.tipo_uni !== "" && form.t_unidad_selec !== "" ){
      this.select_t_carga = form.t_unidad_selec;
      console.log("4",this.select_t_carga);
    }
    */
    if( form.permiso_fed_si ){
      this.permiso_fed_DB = form.permiso_fed_text;
    }else{
      this.permiso_fed_DB = null;
    }

    if(form.remolque_check){
      this.remolque_t_ciculacion = form.t_circ_remolque;
      this.remolque_placas = form.placas_remolque;
    }else{
      this.remolque_t_ciculacion = null;
      this.remolque_placas = null;
    }

    console.log(form.remolque_check);

    console.log("FORMULARIO", form.permiso_fed_si );

      let datos = { "c_carga":form.capacidad, "matricula":form.placa,
                    "nom_unidad":form.unidad_nom, "t_unidad":this.tipo_unidad, "v_especializado": this.vehiculo_esp,
                    "remolque":this.remolque_t_cc_form, "remolque_ref":this.remolque_t_cr_form,
                    "accesorios": this.accesorios_form,"t_carga": this.select_t_carga, "color":form.color, "marca":form.marca,
                    "modelo":form.modelo,"permiso_fed_si": form.permiso_fed_si,"permiso_fed_text":this.permiso_fed_DB,
                    "remolque_check":form.remolque_check, "t_circ_remolque":this.remolque_t_ciculacion,
                    "placas_remolque":this.remolque_placas};

      //console.log(datos);

      this._servicio.act_unidad(datos, this.id).subscribe(data=>{

          if(data){
            $("#editarUnidad").modal('toggle');
            $.notify({
              icon: 'fa fa-truck',
              title:"<b>Se editó unidad</b><br>",
              message:"La unidad del usuario <b>" + this.id + "</b> se editó correctamente"
            });
            this.dataUsuario();
          }

      }, error=>console.log(error));

  }



}



// WEBPACK FOOTER //
// C:/xampp/htdocs/service_tracking/web/service_tracking/src/app/components/usuario/usuario.component.ts